export interface ApiEnvelope<T> {
  sucesso: boolean
  erros: string[]
  data: T | null
}

export interface PagedResult<T> {
  pageIndex: number
  totalPages: number
  totalItems: number
  hasPreviousPage: boolean
  previousPageIndex: number
  hasNextPage: boolean
  nextPageIndex: number
  items: T[]
}

export const emptyPage = <T>(): PagedResult<T> => ({
  pageIndex: 1,
  totalPages: 0,
  totalItems: 0,
  hasPreviousPage: false,
  previousPageIndex: 1,
  hasNextPage: false,
  nextPageIndex: 1,
  items: [],
})
